module.exports = __webpack_public_path__ + "static/turquia-013-db2f702ef638bd182b391d9ba80017e0.jpg";